import { Base } from "../../framework/base";
import { IdColorTitle, IIdColorTitle } from "../common/idColorTitle";
import { IdTitleNode, IIdTitleNode } from "../common/idTitleNode";
import { ITaskEditTypeItem, TaskEditTypeItem } from "../task/taskEditTypeItem";

export interface IAppReportTaskReferenceData {
    taskTypes: ITaskEditTypeItem[];
    taskUnits: IIdTitleNode[];
    taskStates: IIdColorTitle[];
}

export class AppReportTaskReferenceData implements IAppReportTaskReferenceData {
    taskTypes: TaskEditTypeItem[];
    taskUnits: IdTitleNode[];
    taskStates: IdColorTitle[];

    constructor();
    constructor(obj: IAppReportTaskReferenceData);
    constructor(obj?: any) {
        this.taskTypes = Base.getTypedArray(obj?.taskTypes, TaskEditTypeItem);
        this.taskStates = Base.getTypedArray(obj ? obj.taskStates : null, IdColorTitle);
        this.taskUnits = Base.getTypedArray(obj?.taskUnits, IdTitleNode);
    }
}
